/**
 * Marketplace metadata — colors, initials, full names.
 * Used for visual cards in NewOrderPage and badges in HistoryPage.
 */
export const ALL_MARKETPLACES = [
  'Amazon', 'Ebay', 'Kaufland', 'Temu', 'Alibaba', 'AliExpress', 'Allegro', 'Emag',
];

export const MARKETPLACE_META = {
  Amazon:     { initial: 'A',  color: '#FF9900', textColor: '#fff', region: 'Global',     hint: 'PL · DE · FR · ES · IT · UK' },
  Ebay:       { initial: 'e',  color: '#0063D1', textColor: '#fff', region: 'Global',     hint: 'PL · DE · UK · FR' },
  Kaufland:   { initial: 'K',  color: '#E10915', textColor: '#fff', region: 'DACH',       hint: 'DE · AT · SK · CZ' },
  Temu:       { initial: 'T',  color: '#FB7701', textColor: '#fff', region: 'Global',     hint: 'PL · DE · FR · IT · ES' },
  Alibaba:    { initial: 'A',  color: '#FF6A00', textColor: '#fff', region: 'B2B',        hint: 'EN · DE · FR · ES' },
  AliExpress: { initial: 'A',  color: '#E62E04', textColor: '#fff', region: 'Global',     hint: 'PL · DE · FR · ES' },
  Allegro:    { initial: 'a',  color: '#FF5A00', textColor: '#fff', region: 'PL/CZ/SK',   hint: 'PL · CZ · SK · HU' },
  Emag:       { initial: 'e',  color: '#003365', textColor: '#fff', region: 'CEE',        hint: 'RO · HU · BG · PL' },
};

export const ALL_LANGUAGES = [
  'Polski', 'Angielski', 'Niemiecki', 'Francuski', 'Włoski', 'Hiszpański',
  'Niderlandzki', 'Rumuński', 'Czeski', 'Słowacki', 'Węgierski', 'Bułgarski',
  'Chorwacki', 'Duński', 'Fiński', 'Grecki', 'Norweski', 'Portugalski', 'Szwedzki', 'Turecki',
];
